import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useFileDropZoneStyles = makeStyles({
  root: {
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: tokens.spacingVerticalS,
    // the overlay must not steal drag events from the wrapped content
    pointerEvents: 'none',
    backgroundColor: tokens.colorBrandBackground2,
    opacity: 0.92,
    color: tokens.colorBrandForeground1,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    ...shorthands.border('2px', 'dashed', tokens.colorBrandStroke1),
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
  },
  icon: {
    fontSize: '40px',
  },
});
